import { computed } from 'vue';
import { useStore } from "vuex";
import { useField } from 'vee-validate';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useWorkStatusField = (required, messages = {}) => {
  const validator = yup.string()
    .requirement(required, messages['requirement'] || '経験年数は必須項目です');
  const fieldName = computed(() => 'work_status');

  return { fieldName, validator }
}

export const useWorkStatusStore = () => {
  const store = useStore();
  const workStatus = computed(() => store.state.formData.workStatus);
  const workStatuses = computed(() => store.state.masterData.workStatuses);
  const workStatusItem = computed(() => workStatuses.value.find(workStatusInMap => workStatusInMap.value === workStatus.value));
  const dispatcher = computed(() => 'formData/setWorkStatus');

  return { workStatus, workStatuses, workStatusItem, dispatcher }
}